import React, { Component } from "react";
import { connect } from "react-redux";
import {
  savePortalUser,
  getPortalUser,
  getBulkReversals,
} from "../actions/actions";
import "antd/dist/antd.css";
import { Table, message, Button } from "antd";
import { Resizable } from "react-resizable";
import PaginationComponent from "./PaginationComponent";
import BulkUpload from "./BulkUpload";
import ViewBulkTransfersByBatchID from "./ViewBulkTransfersByBatchID";

const ResizeableTitle = (props) => {
  const { onResize, width, ...restProps } = props;

  if (!width) {
    return <th {...restProps} />;
  }

  return (
    <Resizable width={width} height={0} onResize={onResize}>
      <th {...restProps} />
    </Resizable>
  );
};

export class BulkReversal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        {
          title: "Date",
          dataIndex: "dateUploaded",
          width: 150,
        },
        {
          title: "Batch Id",
          dataIndex: "batchId",
          width: 200,
        },
        {
          title: "Count",
          dataIndex: "count",
          width: 150,
        },
        {
          title: "Previously Reversed Count",
          dataIndex: "previouslyReversedCount",
          width: 150,
        },
        {
          title: "Uploaded By",
          dataIndex: "uploadedBy",
          width: 250,
        },
        {
          title: "Processed Count",
          dataIndex: "processedCount",
          width: 150,
        },
        {
          title: "invalid Count",
          dataIndex: "invalidCount",
          width: 150,
        },
        {
          title: "Failed Count",
          dataIndex: "failedCount",
          width: 150,
        },
        {
            title: 'Action',
            key: 'id',
            render: (record) => (
                <div className="action-buttons">
                    <Button className="action-button" type="primary" onClick={() => this.showModal(record)}>View</Button>
                </div>
            ),
        },
      ],
      data: [],
      pageSize: 10,
      pageNo: 1,
      total: 500,
      showViewReversalBatchByID: false,
      batchId: '',
      uploadedBy: '',
      isModalOpen: false
    };

    this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
    this.onPaginationChange = this.onPaginationChange.bind(this);
    this.failAction = this.failAction.bind(this);
  }

  componentDidMount() {
    const payload = {
      data: {
        pageNo: 1,
        pageSize: 10,
      },
      failAction: this.failAction,
    };
    this.props.getBulkReversals(payload);
    this.props.getPortalUser();

    //  this.props.savePortalUser({
    //         id: 1123,
    //          email: "tegssssss@interswitchgroup.com"
    //      });
  }

  componentDidUpdate(prevProps) {
    const { bulkTransactions } = this.props;

    if (bulkTransactions !== prevProps.bulkTransactions) {
      this.setState({
        data: bulkTransactions,
      });
    }
  }

  components = {
    header: {
      cell: ResizeableTitle,
    },
  };

  onViewBatch = (record) => {
    this.setState({showViewReversalBatchByID: true, batchId: record.batchId, uploadedBy: record.uploadedBy});
  }

  showModal = (record) => {
    this.setState({isModalOpen: true, batchId: record.batchId, uploadedBy: record.uploadedBy});
  }

  handleCancel = () => {
    this.setState({isModalOpen: false});
  };

  failAction() {
    message.error("Error processing request at the moment, please try again");
  }

  handleResize =
    (index) =>
    (e, { size }) => {
      this.setState(({ columns }) => {
        const nextColumns = [...columns];
        nextColumns[index] = {
          ...nextColumns[index],
          width: size.width,
        };
        return { columns: nextColumns };
      });
    };

  handlePageSizeChange(value) {
    const newPayload = {
      pageNo: 1,
      pageSize: Number(value),
    }
    this.setState({
      pageSize: newPayload.pageSize,
    });
    const payload = {
      data: newPayload,
      failAction: this.failAction,
    };
    this.props.getBulkReversals(payload);
  }

  onPaginationChange(value) {
    const newPayload = { ...this.props.searchParam };
    newPayload.pageNo = Number(value);
    this.setState({
      pageNo: newPayload.pageNo,
    });
    const payload = {
      data: newPayload,
      failAction: this.failAction,
    };
    this.props.getBulkReversals(payload);
  }

  

  render() {
    const { loading, paginationData, tableLoading } = this.props;
    const columns = this.state.columns.map((col, index) => ({
      ...col,
      onHeaderCell: (column) => ({
        width: column.width,
        onResize: this.handleResize(index),
      }),
    }));

    return (
      <>
    {!this.state.showViewReversalBatchByID &&  <div>
        <h3 style={{ background: "#fff", padding: 0 , color: "rgba(0, 0, 0, 0.65)"}}>
          Bulk Reversals
        </h3>
        <BulkUpload portalUser={this.props.user} />
        <br />
        <br />
        <br />
        <br />
        <PaginationComponent
          onPaginationChange={(item) => this.onPaginationChange(item)}
          handlePageSizeChange={this.handlePageSizeChange}
          loading={loading}
          pageSize={paginationData.pageSize}
          total={paginationData.dataSize}
          showPageSize={true}
        />
        <Table
          bordered
          components={this.components}
          columns={columns}
          dataSource={this.state.data}
          loading={loading || tableLoading}
          pagination={false}
        />
        <PaginationComponent
          onPaginationChange={(item) => this.onPaginationChange(item)}
          handlePageSizeChange={this.handlePageSizeChange}
          loading={loading}
          pageSize={paginationData.pageSize}
          total={paginationData.dataSize}
          showPageSize={false}
        />
      </div>}

      {
         this.state.isModalOpen && <ViewBulkTransfersByBatchID batchId={this.state.batchId} uploadedBy={this.state.uploadedBy} isModalOpen={this.state.isModalOpen} handleCancel={this.handleCancel} showModal={this.showModal}/>
      }
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    bulkTransactions: state.bulkTransactions,
    loading: state.loading,
    tableLoading: state.tableLoading,
    paginationData: state.paginationData,
    user: state.user,
  };
};

export default connect(mapStateToProps, {
  getBulkReversals,
  savePortalUser,
  getPortalUser,
})(BulkReversal);
